/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";

const MobileManagePage = lazy(() => import("./pages/manage"));
const LogEffectPage = lazy(() => import("./pages/log-effect"));
const ActionManagePage = lazy(() => import("./pages/action-manage"));
const ScanLogsPage = lazy(() => import("./pages/scan-logs"));
const DeviceAppPage = lazy(() => import("./pages/device-app"));

const MobileRoutes = [
  { path: "manage", element: <MobileManagePage /> },
  { path: "log-effect", element: <LogEffectPage /> },
  { path: "action-manage", element: <ActionManagePage /> },
  { path: "scan-logs", element: <ScanLogsPage /> },
  { path: "device-app", element: <DeviceAppPage /> },
];
export default MobileRoutes;
